(function () {
  'use strict';

  const STORAGE_KEY = 'snsei_popup_v2';

  function init() {
    // ⛔️ לא בעגלה ולא בקופה: שם הפופאפ מכסה את «לתשלום» ועוצר רכישה.
    const p = window.location.pathname;
    if (p.indexOf('/cart') !== -1 || p.indexOf('/checkout') !== -1 || p.indexOf('/products/') !== -1) return;

    const overlay = document.getElementById('snsei-email-popup');
    if (!overlay) return;

    const closeBtn = document.getElementById('snsei-popup-close');
    const emailInput = document.getElementById('snsei-popup-email');

    function openPopup() {
      overlay.style.display = 'flex';
      emailInput && emailInput.focus();
    }

    function closePopup() {
      overlay.style.display = 'none';
      localStorage.setItem(STORAGE_KEY, '1');
    }

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closePopup();
    });
    closeBtn && closeBtn.addEventListener('click', closePopup);

    // Shopify redirects back with ?customer_posted= after the form submits, and the
    // snippet renders the success state server-side. Reopen so the visitor sees it.
    if (window.location.search.indexOf('customer_posted=') !== -1) {
      localStorage.setItem(STORAGE_KEY, '1');
      openPopup();
      setTimeout(function () { overlay.style.display = 'none'; }, 6000);
      return;
    }

    // ⛔️ 19/08, טריגר הכניסה (10 שניות) בוטל, הכרעת מוטי.
    // הוא כיסה את המסך ב-z-index 9999 ועשה את כפתור הוואטסאפ בלתי-לחיץ,
    // כולל בעמוד הנחיתה של המודעה הממומנת. נמדד: elementFromPoint על מרכז
    // הכפתור החזיר את האוברלי ולא את הכפתור.
    // איסוף המיילים ממשיך דרך פופאפ היציאה (sensei-exit-popup.js), שנפתח
    // ב-mouseleave בדסקטופ ובגלילה חזרה למעלה במובייל.
    // ⚠️ ענף ה-customer_posted= למעלה חייב להישאר: הוא מציג את מסך ההצלחה
    // עם קוד CLUB10 גם כשהטופס נשלח מפופאפ היציאה.
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
